// ID завода с бу автомобилями
export const USED_CAR_FACTORY_ID = 36;

// Порядок заводов в выпадающем списке (перечисленные идут первыми, остальные — как с бэкенда)
export const FACTORY_ORDER_PRIORITY = ['САП', 'AMQ'];

// Типы происхождения автомобилей
export const CAR_ORIGIN_TYPES = {
  NEW_KZ: 1,                    // Новое авто, произведённое в Казахстане
  NEW_IMPORT: 2,            // Новое авто, ввезённое
  PURCHASE: 3,                // Выкуп у клиента
  PLEDGED_PURCHASE: 4, // Выкуп залогового авто
  EXCHANGE: 5,                // По договору мены
  CONSIGNMENT: 6,          // По договору поручения
};

// Описания типов происхождения
export const CAR_ORIGIN_LABELS = {
  [CAR_ORIGIN_TYPES.NEW_KZ]: 'Новое авто, произведённое в Казахстане',
  [CAR_ORIGIN_TYPES.NEW_IMPORT]: 'Новое авто, ввезённое',
  [CAR_ORIGIN_TYPES.PURCHASE]: 'Выкуп у клиента',
  [CAR_ORIGIN_TYPES.PLEDGED_PURCHASE]: 'Выкуп залогового авто',
  [CAR_ORIGIN_TYPES.EXCHANGE]: 'По договору мены',
  [CAR_ORIGIN_TYPES.CONSIGNMENT]: 'По договору поручения',
};

// Типы, требующие процесс выкупа
export const PURCHASE_PROCESS_TYPES = [
  CAR_ORIGIN_TYPES.PURCHASE,
  CAR_ORIGIN_TYPES.PLEDGED_PURCHASE,
  CAR_ORIGIN_TYPES.EXCHANGE,
  CAR_ORIGIN_TYPES.CONSIGNMENT,
];

// Типы документов выкупа
export const PURCHASE_DOCUMENT_TYPES = {
  PURCHASE_CONTRACT: 'purchase_contract',       // Договор выкупа
  INSPECTION_ACT: 'inspection_act',            // Акт приёмки/осмотра
  CAR_PHOTOS: 'car_photos',                    // Фотографии автомобиля
  SIGNED_CONTRACT: 'signed_contract',          // Подписанный договор
};

// Типы договоров по происхождению
export const CONTRACT_TYPES_BY_ORIGIN = {
  [CAR_ORIGIN_TYPES.PURCHASE]: 'purchase',
  [CAR_ORIGIN_TYPES.PLEDGED_PURCHASE]: 'pledged_purchase',
  [CAR_ORIGIN_TYPES.EXCHANGE]: 'exchange',
  [CAR_ORIGIN_TYPES.CONSIGNMENT]: 'consignment',
};

// Статусы обработки выкупа
export const PURCHASE_STATUS = {
  PENDING: 'pending',           // В обработке
  DOCUMENTS_UPLOADED: 'docs_uploaded', // Документы загружены
  CONTRACT_GENERATED: 'contract_generated', // Договор сгенерирован
  CONTRACT_SIGNED: 'contract_signed', // Договор подписан
  COMPLETED: 'completed',       // Завершено
  CANCELLED: 'cancelled',       // Отменено
};

// Требуемые документы для каждого типа
export const REQUIRED_DOCUMENTS_BY_TYPE = {
  [CAR_ORIGIN_TYPES.PURCHASE]: [
    PURCHASE_DOCUMENT_TYPES.PURCHASE_CONTRACT,
    PURCHASE_DOCUMENT_TYPES.INSPECTION_ACT,
    PURCHASE_DOCUMENT_TYPES.CAR_PHOTOS,
  ],
  [CAR_ORIGIN_TYPES.PLEDGED_PURCHASE]: [
    PURCHASE_DOCUMENT_TYPES.PURCHASE_CONTRACT,
    PURCHASE_DOCUMENT_TYPES.INSPECTION_ACT,
    PURCHASE_DOCUMENT_TYPES.CAR_PHOTOS,
  ],
  [CAR_ORIGIN_TYPES.EXCHANGE]: [
    PURCHASE_DOCUMENT_TYPES.PURCHASE_CONTRACT,
    PURCHASE_DOCUMENT_TYPES.INSPECTION_ACT,
    PURCHASE_DOCUMENT_TYPES.CAR_PHOTOS,
  ],
  [CAR_ORIGIN_TYPES.CONSIGNMENT]: [
    PURCHASE_DOCUMENT_TYPES.PURCHASE_CONTRACT,
    PURCHASE_DOCUMENT_TYPES.CAR_PHOTOS,
  ],
}; 